import { memo, useState } from 'react';
import { Button } from 'react-admin';
import Drawer from '@mui/material/Drawer'
import Toolbar from '@mui/material/Toolbar'

function DevAppBar() {
  const [dev, setDev] = useState(false);
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [jsonViewSrc, setJsonViewSrc] = useState<any | null>(null);

  // const showJsonFromUrl = (src: string) => {
  //   setIframeSrc(null);
  //   fetch(src).then(r => r.json()).then(setJsonViewSrc);
  // }
  const showIframe = (src: string) => {
    setJsonViewSrc(null);
    setIframeSrc(src);
  }

  return (
    <>
      <Button color="primary" variant="contained" label="Dev" onClick={() => setDev(true)} />
      <Drawer anchor="right" open={dev} onClose={() => setDev(false)} PaperProps={{ sx: { width: "80vw" } }}>
        <Toolbar>
          <Button color="primary" sx={{ mx: 1 }} variant="contained" label="OpenApi" onClick={() => showIframe('/api/openapi')} />
          <Button color="primary" sx={{ mx: 1 }} variant="contained" label="Swagger" onClick={() => showIframe('/api/dev/swagger')} />
          <Button color="primary" sx={{ mx: 1 }} variant="contained" label="Cache Clear" onClick={() => showIframe('/api/cache/clear')} />
          <Button color="primary" sx={{ mx: 1 }} variant="contained" label="Dev Main" onClick={() => showIframe('/api/dev/main')} />
          <Button color="secondary" sx={{ mx: 1 }} variant="contained" label="Db2Ts" onClick={() => showIframe('/api/dev/db-2-ts')} />
          <Button color="secondary" sx={{ mx: 1 }} variant="contained" label="Db2Ra" onClick={() => showIframe('/api/dev/db-2-ra')} />
          <Button color="secondary" sx={{ mx: 1 }} variant="contained" label="Build PHP" onClick={() => showIframe('/api/dev/code-build')} />
        </Toolbar>
        {null !== iframeSrc ? <iframe frameBorder="none" style={{ width: "100%", height: "100%", }} src={iframeSrc} title="the iframe"></iframe> : null}
        {null !== jsonViewSrc ? <pre dangerouslySetInnerHTML={{"__html": JSON.stringify(jsonViewSrc, null, 2)}}></pre> : null}
      </Drawer>
    </>
  )
}

export default memo(DevAppBar);
